
import { APP_RETIREMENT_URLS } from "../../const/AppConst";
import { staticBaseUrl } from "../../config/GlobalConfig";
import useAppState from "../../context/AppContext";
import MenuREItem from "../../components/retirement/menuREItem";


type RESidePannelRetirementBloc = {
  isActive ?: boolean
}
export default function RESidePannelRetirementBloc({isActive}: Readonly<RESidePannelRetirementBloc>) {
  const {
    state: { infoSteps}
  } = useAppState();

  let styledClass = "adherent-lateralnav lateral-nav bg-blanc shadow-bleu";
  if(isActive === false)  styledClass += ' unactive';

  return (
    <aside className={styledClass}>
      <img src={staticBaseUrl + "/img/mgp.svg"} alt="MGP" className="m-x-xl m-y-lg ta-center sc-appear-fromtop logo isreveal"/>
    
      <div className="hide-in-mobile">
      
        
          <MenuREItem label='Je renseigne ma situation' name="SITUATION" path={APP_RETIREMENT_URLS.situationPage}
          />
        
          <MenuREItem label="Je définis mes besoins" name="BESOIN" path={APP_RETIREMENT_URLS.besoinPage}
          />
      
          <MenuREItem label="Je choisis ma couverture"name="GUARANTY" path={APP_RETIREMENT_URLS.guarantyPage}
          />
       
          <MenuREItem label="J'adhère" name="INFO" path={APP_RETIREMENT_URLS.infoIdentityPage} subMenuItems={infoSteps.filter(step => step.category === 'INFO')}
          />
      </div>
      
     
    </aside>
  )
}
